<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <b-row class="pt-sm-1">
                    <b-col sm="1">
                        <span class="card-title wise-card-title">검색 조건</span>
                    </b-col>
                    <b-col sm="1"><strong>검색어</strong></b-col>
                    <b-col sm="8">
                        <b-form-input v-model="queryParams.name" placeholder=""
                            v-on:keyup="$event.keyCode === 13 ? findUser() : ''"></b-form-input>
                    </b-col>
                    <b-col sm="2" style="text-align: center;">
                        <b-button variant="primary" style="width: 100%;" v-on:click="findUser()">검색</b-button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>가입기간</strong></b-col>
                    <b-col sm="3">
                        <date-picker v-model="fullDateTmp"
                                    type="date"
                                    style="width: 100%;"
                                    range
                                    placeholder="조회기간 선택"
                                    :lang="datepickerLang"
                                    @change="handleDateRangeChange"
                        />
                    </b-col>
                    <b-col sm="6">
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
                    </b-col>
                </b-row>
              <b-row class="pt-sm-2" v-if="!modalFalg">
                <b-col sm="1"></b-col>
                <b-col sm="1"><strong>수정기간</strong></b-col>
                <b-col sm="3">
                  <date-picker v-model="fullUptDateTmp"
                               type="date"
                               style="width: 100%;"
                               range
                               placeholder="조회기간 선택"
                               :lang="datepickerLang"
                               @change="handleUptDateRangeChange"
                  />
                </b-col>
                <b-col sm="6">
                  <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="uptDateRange('ALL')">전체</button>
                  <button type="button" class="btn btn-outline-primary" v-on:click="uptDateRange('1WEEK')">1주일</button>
                  <button type="button" class="btn btn-outline-primary" v-on:click="uptDateRange('1MONTH')">1개월</button>
                  <button type="button" class="btn btn-outline-primary" v-on:click="uptDateRange('6MONTH')">6개월</button>
                  <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="uptDateRange('1YEAR')">1년</button>
                </b-col>
              </b-row>
                <b-row v-if="!modalFalg" class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>마케팅수신동의</strong></b-col>
                    <b-col sm="4" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckMarketing" style="padding-right: 15px;" @change="allCheckMarketing">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.letter_yn" @click.native="isCheckMarketing = false">
                            <b-form-checkbox value="Y">동의</b-form-checkbox>
                            <b-form-checkbox value="N">비동의</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>
                <b-row v-if="!modalFalg" class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>회원구분</strong></b-col>
                    <b-col sm="5" style="width: 100%;">
                        <div style="display: inline-flex;">
                            <!-- 여기서 사용되는 회원 구분은 각 상태마다 쿼리가 다릅니다. IN 조건 아님 -->
                            <b-form-checkbox v-model="isCheckUserType" style="padding-right: 15px;" @change="allCheckUserType">전체</b-form-checkbox>
                            <b-form-checkbox-group v-model="queryParams.authority" @click.native="isCheckUserType = false">
                                <b-form-checkbox value="NORMAL">활성회원</b-form-checkbox>
                                <b-form-checkbox value="COMPANY">구독회원</b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>
                    </b-col>
                    <b-col sm="1"><strong>회원 기타구분</strong></b-col>
                    <b-col sm="3" style="width: 100%;">
                        <div style="display: inline-flex;">
                            <b-form-checkbox-group v-model="queryParams.user_status">
                                <b-form-checkbox value="2">휴면회원</b-form-checkbox>
                            </b-form-checkbox-group>
                            <b-form-checkbox-group v-model="queryParams.employee">
                                <b-form-checkbox value="Y">DMC직원제외</b-form-checkbox>
                            </b-form-checkbox-group>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="!modalFalg" class="pt-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1">
                        <strong>기업분류</strong>
                        <i v-if="!isOpen" v-on:click="fnOpenClose()" class="fa fa-caret-square-o-up fa-lg"></i>
                        <i v-if="isOpen" v-on:click="fnOpenClose()" class="fa fa-caret-square-o-down fa-lg"></i>
                    </b-col>
                    <b-col sm="9" class="industry_area">
                        <b-form-checkbox v-model="isCheckCompnayType" style="padding-right: 15px;" @change="allCheckCompnayType">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.industry_key" @click.native="isCheckCompnayType = false">
                            <template v-for="(item, index) in industryList">
                                <b-form-checkbox :value="item.industry_code">{{item.industry_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                    <!-- <b-col sm="1" v-on:click="fnOpenClose()" style="cursor: pointer;">
                        <i v-if="!isOpen" class="fa fa-caret-square-o-up fa-lg"></i>
                        <i v-if="isOpen" class="fa fa-caret-square-o-down fa-lg"></i>
                    </b-col> -->
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'
import swal from 'sweetalert2'

import { EventBus } from "../../../event-bus";

export default {
    name: "userSearch",
    props: {
        queryParams: {
            name: {
                type: String,
            },
            ageRange: {
                type: Array,
            },
            letter_yn: {
                type: Array,
            },
            industry_key: {
                type: Array,
            },
            authority: {
                type: Array,
            },
            user_status: {
                type: Array,
            },
            employee : {
                type: Array,
            },
        },
        fullDate: {
            type: Array,
        },
        fullUptDate : {
            type: Array,
        },
        modalFalg: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
            industryList: [],
            isOpen: false,
            fullDateTmp: [],
            fullUptDateTmp: [],
            isCheckMarketing: false,
            isCheckUserType: false,
            isCheckCompnayType : false,
        }
    },
    mounted() {
        if(!this.modalFalg){
            this.fnOpenClose();
            this.getIndustryCodeList();
        }
    },
    watch: {
    },
    components: {
        DatePicker,
    },
    methods: {
        // 기업 분류 목록
        getIndustryCodeList() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/industryCodeList?access_token=' + token)
              .then((result) => {
                const { data } = result;
                // console.log('getIndustryCodeList() : ', data);
                this.industryList = data;
            });
        },
        // 접기 펼치기 버튼
        fnOpenClose() {
            this.isOpen = !this.isOpen;
            if(this.isOpen){
                document.querySelector('.industry_area').style.height = '20px';
                document.querySelector('.industry_area').style.overflow = 'hidden';
            }else{
                document.querySelector('.industry_area').style.height = '';
            }
        },
        // 검색하기 버튼 클릭 이벤트
        findUser() {
            this.queryParams.name = this.queryParams.name.replace(/\s/g, '');
            if(this.modalFalg) {
                if(this.fullDateTmp.length === 0 && this.queryParams.name === ""){
                    swal.fire({
                        type: 'warning',
                        title: '검색어 또는 가입기간을 선택하여 주세요.',
                        showConfirmButton: true,
                    })
                }else{
                    EventBus.$emit('callModalFindUser', this.fullDateTmp);
                }
            }else{
                EventBus.$emit('callFindUser');
                EventBus.$emit('callUserStatistics');
            }
        },
        // 날짜 정의
        dateRange(flag) {
            let endDate;
            let startDate;
            if(this.fullDateTmp.length === 0){
                endDate = new Date();
                startDate = new Date();
            }else{
                endDate = this.fullDateTmp[1];
                startDate = _.clone(this.fullDateTmp[1]);
            }

            if(flag == '1WEEK'){
                startDate.setDate(endDate.getDate() - 7);
            }else if(flag == '1MONTH'){
                startDate.setMonth(endDate.getMonth() - 1);
            }else if(flag == '6MONTH'){
                startDate.setMonth(endDate.getMonth() - 6);
            }else if(flag == '1YEAR'){
                startDate.setFullYear(endDate.getFullYear() - 1);
            }
            this.fullDateTmp = [startDate, endDate];
            if(flag == 'ALL'){
                this.fullDateTmp = [];
            }
            this.handleDateRangeChange();
        },
        handleDateRangeChange() {
            this.$parent.fullDate = this.fullDateTmp;
            // console.log('>>>>', this.$parent.fullDate);
        },
      uptDateRange(flag) {
        let endUptDate;
        let startUptDate;
        if(this.fullUptDateTmp.length === 0){
          endUptDate = new Date();
          startUptDate = new Date();
        }else{
          endUptDate = this.fullUptDateTmp[1];
          startUptDate = _.clone(this.fullUptDateTmp[1]);
        }

        if(flag == '1WEEK'){
          startUptDate.setDate(endUptDate.getDate() - 7);
        }else if(flag == '1MONTH'){
          startUptDate.setMonth(endUptDate.getMonth() - 1);
        }else if(flag == '6MONTH'){
          startUptDate.setMonth(endUptDate.getMonth() - 6);
        }else if(flag == '1YEAR'){
          startUptDate.setFullYear(endUptDate.getFullYear() - 1);
        }
        this.fullUptDateTmp = [startUptDate, endUptDate];
        if(flag == 'ALL'){
          this.fullUptDateTmp = [];
        }
        this.handleUptDateRangeChange();
      },
        handleUptDateRangeChange() {
            this.$parent.fullUptDate = this.fullUptDateTmp;
            //console.log('>>>>', this.$parent.fullDate);
        },
        allCheckMarketing(){
            this.isCheckMarketing = !this.isCheckMarketing;
            if(this.isCheckMarketing) {
                this.queryParams.letter_yn = ["Y", "N"];
            }else{
                this.queryParams.letter_yn = [];
            }
        },
        allCheckUserType(){
            this.isCheckUserType = !this.isCheckUserType;
            if(this.isCheckUserType){
                this.queryParams.authority = ["NORMAL", "COMPANY"];
                // this.queryParams.user_status = ["2"];
                // this.queryParams.employee = ["Y"];
            }else{
                this.queryParams.authority = [];
                // this.queryParams.user_status = [];
                // this.queryParams.employee = [];
            }
        },
        allCheckCompnayType() {
            this.isCheckCompnayType = !this.isCheckCompnayType;
            if(this.isCheckCompnayType){
                this.queryParams.industry_key = [];
                this.industryList.forEach((data) => {
                    this.queryParams.industry_key.push(data.industry_code);
                });
            }else{
                this.queryParams.industry_key = [];
            }
        },
    },
    filters: {

    }
}
</script>



// WEBPACK FOOTER //
// src/views/user/userList/component/UserSearch.vue